import ColorView from '../../../../structures/colorView';

export default class NullLabel {
	name: string;

	constructor( name = 'No Label' ) {
		this.name = name;
	}

	get id() {
		return null;
	}

	get isCustom() {
		return false;
	}

	get labellableID() {
		return undefined;
	}

	get labellableType() {
		return undefined;
	}

	get order() {
		return undefined;
	}

	get color() {
		return new ColorView( { base: 'var(--color-label-grey)' } );
	}

	get textColor() {
		return new ColorView( { base: 'var(--color-text-primary)' } );
	}
}
